/* ==========================================================================
   Mondō London — product gallery
   One large main image + a thumbnail strip. Click a thumb to swap the main;
   serif arrows either side step through with wrap-around.
   ========================================================================== */
(function () {
  'use strict';

  function thumbs() { return Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]')); }

  var swapToken = 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pdpMediaSizes = '(min-width: 940px) 50vw, 100vw';
  var pdpDesktopMedia = window.matchMedia && window.matchMedia('(min-width: 940px)');

  // Shopify production emits these wrappers directly. The canonical local
  // preview proxies live markup, so build the same structure when reviewing a
  // newer local composition against the live product data.
  function ensurePdpDetails() {
    var product = document.querySelector('.template-product .product');
    var identity = product && product.querySelector('.pdp-identity');
    var info = product && product.querySelector('.info');
    if (!product || !identity || !info) return null;

    var details = product.querySelector('.pdp-details');
    if (details) return details;

    details = document.createElement('div');
    details.className = 'pdp-details';
    var sticky = document.createElement('div');
    sticky.className = 'pdp-details__sticky';
    var content = document.createElement('div');
    content.className = 'pdp-details__content';
    product.insertBefore(details, identity);
    details.appendChild(sticky);
    sticky.appendChild(content);
    content.appendChild(identity);
    content.appendChild(info);
    return details;
  }

  function ensurePdpImageStack() {
    var gallery = document.querySelector('.template-product .gallery');
    if (!gallery) return null;
    var stack = gallery.querySelector('[data-pdp-gallery-stack]');
    if (!stack) {
      var sources = thumbs();
      var main = document.querySelector('[data-gallery-main]');
      if (!sources.length && main) sources = [main];
      if (!sources.length) return null;

      stack = document.createElement('div');
      stack.className = 'pdp-gallery-stack';
      stack.setAttribute('data-pdp-gallery-stack', '');
      var zoom = document.querySelector('[data-gallery-zoom]');
      var zoomLabel = zoom && zoom.getAttribute('aria-label') || 'Zoom image';

      sources.forEach(function (source, index) {
        var sourceImage = source.querySelector && source.querySelector('img');
        var full = source.getAttribute('data-full') || source.currentSrc || source.getAttribute('src');
        var alt = source.getAttribute('data-alt') || source.getAttribute('alt') || '';
        if (!full) return;

        var item = document.createElement('button');
        item.className = 'pdp-gallery-stack__item';
        item.setAttribute('type', 'button');
        item.setAttribute('data-gallery-stack-trigger', '');
        item.setAttribute('data-gallery-index', String(index));
        item.setAttribute('data-full', full);
        item.setAttribute('data-alt', alt);
        item.setAttribute('aria-label', zoomLabel + ' ' + (index + 1));

        var image = document.createElement('img');
        image.className = 'pdp-gallery-stack__image';
        image.setAttribute('src', full);
        image.setAttribute('sizes', '50vw');
        image.setAttribute('alt', alt);
        image.setAttribute('loading', index === 0 ? 'eager' : 'lazy');
        image.setAttribute('decoding', 'async');
        if (index === 0) image.setAttribute('fetchpriority', 'high');
        var width = source.getAttribute('data-width') || (sourceImage && sourceImage.getAttribute('width')) || (index === 0 && main && main.getAttribute('width'));
        var height = source.getAttribute('data-height') || (sourceImage && sourceImage.getAttribute('height')) || (index === 0 && main && main.getAttribute('height'));
        if (width) image.setAttribute('width', width);
        if (height) image.setAttribute('height', height);
        item.appendChild(image);
        stack.appendChild(item);
      });
      gallery.insertBefore(stack, gallery.firstChild);
    }
    gallery.classList.add('has-scroll-stack');
    return stack;
  }

  var pdpDetails = ensurePdpDetails();
  function updateDetailsFit() {
    if (!pdpDetails) return;
    pdpDetails.classList.toggle('can-stick', Boolean(pdpDesktopMedia && pdpDesktopMedia.matches));
  }

  function refreshPdpSpread() {
    if (pdpDesktopMedia && pdpDesktopMedia.matches) ensurePdpImageStack();
    updateDetailsFit();
  }

  refreshPdpSpread();
  if (pdpDetails && typeof ResizeObserver !== 'undefined') {
    var detailsObserver = new ResizeObserver(updateDetailsFit);
    detailsObserver.observe(pdpDetails.querySelector('.pdp-details__content'));
  }
  window.addEventListener('resize', updateDetailsFit, { passive: true });
  if (pdpDesktopMedia) {
    if (pdpDesktopMedia.addEventListener) pdpDesktopMedia.addEventListener('change', refreshPdpSpread);
    else if (pdpDesktopMedia.addListener) pdpDesktopMedia.addListener(refreshPdpSpread);
  }

  // The production Liquid stage receives this ratio inline. The local review
  // surface proxies live markup, so mirror it from the opening image's
  // intrinsic attributes to keep the mock faithful without changing slides.
  function primePdpStage() {
    var stage = document.querySelector('.template-product .gallery-main');
    var main = document.querySelector('[data-gallery-main]');
    if (!stage || !main) return;
    var width = Number.parseFloat(main.getAttribute('width'));
    var height = Number.parseFloat(main.getAttribute('height'));
    if (width > 0 && height > 0) {
      stage.style.setProperty('--pdp-media-ratio', width + ' / ' + height);
    }
    main.setAttribute('sizes', pdpMediaSizes);
  }

  primePdpStage();

  // The opening image has an LCP-oriented srcset. Once another record is
  // selected, remove those first-image candidates before changing src so the
  // browser cannot keep displaying a stale responsive candidate.
  function clearResponsiveCandidates(image) {
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
  }

  function announce(target, description) {
    var list = thumbs();
    var current = Math.max(1, list.indexOf(target) + 1);
    var counter = document.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = current + ' / ' + list.length;
    var status = document.querySelector('[data-gallery-status]');
    if (!status) return;
    var template = status.getAttribute('data-gallery-template') ||
      'Image [current] of [total]: [description]';
    status.textContent = template
      .replace('[current]', String(current))
      .replace('[total]', String(list.length))
      .replace('[description]', description || '');
  }

  // overlay layer for dissolves: the new image fades in OVER the old one,
  // so the photograph never dips toward the background mid-swap
  function xfadeLayer(main) {
    var layer = main.parentElement.querySelector('.gallery-xfade');
    if (!layer) {
      layer = document.createElement('img');
      layer.className = 'gallery-xfade';
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('alt', '');
      main.parentElement.appendChild(layer);
    }
    return layer;
  }

  function show(t) {
    var main = document.querySelector('[data-gallery-main]');
    if (!main || !t) return;
    thumbs().forEach(function (x) {
      var active = x === t;
      x.classList.toggle('is-active', active);
      x.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var full = t.getAttribute('data-full');
    var alt = t.getAttribute('data-alt');
    var token = ++swapToken;
    if (!full) return;
    if (main.getAttribute('src') === full) {
      var pendingLayer = main.parentElement.querySelector('.gallery-xfade');
      if (pendingLayer) pendingLayer.classList.remove('is-in');
      announce(t, alt);
      return;
    }

    if (reduceMotion) {
      clearResponsiveCandidates(main);
      main.setAttribute('src', full);
      if (alt != null) main.setAttribute('alt', alt);
      announce(t, alt);
      return;
    }
    var pre = new Image();
    pre.src = full;
    var ready = pre.decode
      ? pre.decode().catch(function () {})
      : new Promise(function (res) { pre.onload = res; pre.onerror = res; });
    ready.then(function () {
      if (token !== swapToken) return; // a later hover superseded this one
      var layer = xfadeLayer(main);
      // if a dissolve is mid-flight, commit its frame beneath before retargeting
      if (layer.classList.contains('is-in') && layer.getAttribute('src')) {
        clearResponsiveCandidates(main);
        main.setAttribute('src', layer.getAttribute('src'));
      }
      layer.setAttribute('src', full);
      layer.classList.remove('is-in');
      void layer.offsetWidth;
      layer.classList.add('is-in');
      var done = function (e) {
        if (e.propertyName !== 'opacity') return;
        layer.removeEventListener('transitionend', done);
        if (token !== swapToken) return;
        clearResponsiveCandidates(main);
        main.setAttribute('src', full);
        if (alt != null) main.setAttribute('alt', alt);
        layer.classList.remove('is-in'); // invisible: main now holds the same frame
        announce(t, alt);
      };
      layer.addEventListener('transitionend', done);
    });
  }

  thumbs().forEach(function (x) {
    x.setAttribute('aria-pressed', x.classList.contains('is-active') ? 'true' : 'false');
  });

  function step(dir) {
    var list = thumbs();
    if (!list.length) return;
    var i = list.findIndex(function (x) { return x.classList.contains('is-active'); });
    show(list[(i + dir + list.length) % list.length]);
  }

  // Touch and pen users keep the same gallery state machine as arrows, thumbs,
  // and keys. Vertical movement and pinch zoom stay native to the page.
  var swipeViewport = document.querySelector('[data-gallery-swipe]');
  var swipe = null;
  if (swipeViewport && thumbs().length > 1 && window.PointerEvent) {
    swipeViewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
      if (e.button != null && e.button !== 0) return;
      if (e.isPrimary === false) { swipe = null; return; }
      if (e.target.closest && e.target.closest('[data-gallery-prev],[data-gallery-next]')) return;
      if (swipe && swipe.pointerId !== e.pointerId) { swipe = null; return; }
      swipe = { pointerId: e.pointerId, x: e.clientX, y: e.clientY };
    }, { passive: true });

    swipeViewport.addEventListener('pointerup', function (e) {
      if (!swipe || e.pointerId !== swipe.pointerId) return;
      var dx = e.clientX - swipe.x;
      var dy = e.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy)) return;
      swipeViewport.setAttribute('data-gallery-swiped', 'true');
      setTimeout(function () { swipeViewport.removeAttribute('data-gallery-swiped'); }, 400);
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    swipeViewport.addEventListener('pointercancel', function (e) {
      if (swipe && e.pointerId === swipe.pointerId) swipe = null;
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest ? e.target.closest('[data-gallery-thumb],[data-gallery-prev],[data-gallery-next]') : null;
    if (!c) return;
    e.preventDefault();
    if (c.hasAttribute('data-gallery-prev')) step(-1);
    else if (c.hasAttribute('data-gallery-next')) step(1);
    else show(c);
  });

  // hover previews without requiring a click (no-op on touch devices)
  document.addEventListener('mouseover', function (e) {
    var t = e.target.closest ? e.target.closest('[data-gallery-thumb]') : null;
    if (t && !t.classList.contains('is-active')) show(t);
  });


  // arrow keys page the gallery only while it holds focus — a reader tabbing
  // through the rest of the page keeps their arrows (and Alt+Left stays back)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    if (pdpDesktopMedia && pdpDesktopMedia.matches && document.querySelector('.template-product .gallery.has-scroll-stack')) return;
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    var scope = main.closest('.gallery, .archive-object__media');
    if (!scope || !scope.contains(document.activeElement)) return;
    e.preventDefault();
    step(e.key === 'ArrowLeft' ? -1 : 1);
  });

  /* PDP scroll cue — the lower-right foil arrow: a click nudges the page down,
     and it fades out the moment the reader starts moving. */
  (function () {
    var cue = document.querySelector('[data-pdp-scroll]');
    if (!cue) return;
    cue.addEventListener('click', function () {
      window.scrollBy({ top: Math.round(window.innerHeight * 0.88), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      document.body.classList.toggle('pdp-cue-off', y > 24);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();
})();

/* PDP image spotlight — click or tap the uncropped catalogue plate to inspect
   it at a larger scale over a blurred duplicate. */
(function () {
  'use strict';
  var wrap = document.querySelector('.template-product .gallery-main');
  var main = document.querySelector('[data-gallery-main]');
  var control = document.querySelector('[data-gallery-zoom]');
  var previousControl = document.querySelector('.template-product [data-gallery-prev]');
  var nextControl = document.querySelector('.template-product [data-gallery-next]');
  if (!wrap || !main || !control || !document.body || !document.body.appendChild) return;

  var label = control.getAttribute('aria-label') || 'View full image';
  var trigger = document.createElement('button');
  trigger.className = 'gallery-spotlight-trigger';
  trigger.setAttribute('type', 'button');
  trigger.setAttribute('aria-label', label);
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-controls', 'pdp-image-spotlight');
  trigger.setAttribute('aria-expanded', 'false');
  wrap.appendChild(trigger);

  var spotlight = document.createElement('div');
  spotlight.className = 'pdp-spotlight';
  spotlight.id = 'pdp-image-spotlight';
  spotlight.hidden = true;
  spotlight.setAttribute('role', 'dialog');
  spotlight.setAttribute('aria-modal', 'true');
  spotlight.setAttribute('aria-label', label);

  var backdrop = document.createElement('img');
  backdrop.className = 'pdp-spotlight__backdrop';
  backdrop.setAttribute('alt', '');
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.setAttribute('decoding', 'async');
  backdrop.setAttribute('draggable', 'false');

  var image = document.createElement('img');
  image.className = 'pdp-spotlight__image';
  image.setAttribute('decoding', 'async');
  image.setAttribute('draggable', 'false');

  var close = document.createElement('button');
  close.className = 'pdp-spotlight__close';
  close.setAttribute('type', 'button');
  close.setAttribute('aria-label', 'Close');

  spotlight.appendChild(backdrop);
  spotlight.appendChild(image);
  var previous = null;
  var next = null;
  if (previousControl && nextControl) {
    previous = previousControl.cloneNode(true);
    previous.className = 'pdp-spotlight__nav pdp-spotlight__nav--prev';
    previous.removeAttribute('data-gallery-prev');
    next = nextControl.cloneNode(true);
    next.className = 'pdp-spotlight__nav pdp-spotlight__nav--next';
    next.removeAttribute('data-gallery-next');
    spotlight.appendChild(previous);
    spotlight.appendChild(next);
  }
  spotlight.appendChild(close);
  document.body.appendChild(spotlight);

  control.removeAttribute('aria-pressed');
  control.setAttribute('aria-haspopup', 'dialog');
  control.setAttribute('aria-controls', spotlight.id);
  control.setAttribute('aria-expanded', 'false');

  var closeTimer = 0;
  var opener = trigger;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncSpotlight() {
    var active = document.querySelector('[data-gallery-thumb].is-active');
    var source = active && active.getAttribute('data-full');
    var alt = active && active.getAttribute('data-alt');
    source = source || main.currentSrc || main.getAttribute('src');
    alt = alt || main.getAttribute('alt') || '';
    if (!source) return;
    backdrop.setAttribute('src', source);
    image.setAttribute('src', source);
    image.setAttribute('alt', alt);
    spotlight.setAttribute('aria-label', alt || label);
  }

  function openSpotlight(e) {
    if (wrap.hasAttribute('data-gallery-swiped')) return;
    opener = e && e.currentTarget ? e.currentTarget : trigger;
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = 0;
    }
    syncSpotlight();
    spotlight.hidden = false;
    document.body.classList.add('pdp-spotlight-open');
    trigger.setAttribute('aria-expanded', 'true');
    control.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      spotlight.classList.add('is-open');
      requestAnimationFrame(function () { close.focus(); });
    });
  }

  function closeSpotlight() {
    if (spotlight.hidden) return;
    spotlight.classList.remove('is-open');
    document.body.classList.remove('pdp-spotlight-open');
    trigger.setAttribute('aria-expanded', 'false');
    control.setAttribute('aria-expanded', 'false');
    if (reduceMotion) {
      spotlight.hidden = true;
    } else {
      closeTimer = setTimeout(function () {
        spotlight.hidden = true;
        closeTimer = 0;
      }, 320);
    }
    opener.focus();
  }

  function moveSpotlight(sourceControl) {
    if (!sourceControl) return;
    sourceControl.click();
    syncSpotlight();
  }

  trigger.addEventListener('click', openSpotlight);
  control.addEventListener('click', openSpotlight);
  document.addEventListener('click', function (e) {
    var stackTrigger = e.target.closest ? e.target.closest('[data-gallery-stack-trigger]') : null;
    if (!stackTrigger) return;
    e.preventDefault();
    var index = parseInt(stackTrigger.getAttribute('data-gallery-index'), 10);
    var state = document.querySelectorAll('[data-gallery-thumb]')[index];
    if (state) state.click();
    openSpotlight({ currentTarget: stackTrigger });
  });
  if (previous) {
    previous.addEventListener('click', function (e) {
      e.stopPropagation();
      moveSpotlight(previousControl);
    });
  }
  if (next) {
    next.addEventListener('click', function (e) {
      e.stopPropagation();
      moveSpotlight(nextControl);
    });
  }
  close.addEventListener('click', function (e) {
    e.stopPropagation();
    closeSpotlight();
  });
  spotlight.addEventListener('click', closeSpotlight);
  document.addEventListener('focusin', function (e) {
    if (spotlight.classList.contains('is-open') && !spotlight.contains(e.target)) close.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (spotlight.hidden) return;
    if (e.key === 'Escape') closeSpotlight();
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      moveSpotlight(previousControl);
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      moveSpotlight(nextControl);
    }
    if (e.key === 'Tab') {
      e.preventDefault();
      var focusable = [previous, close, next].filter(Boolean);
      var index = focusable.indexOf(document.activeElement);
      var direction = e.shiftKey ? -1 : 1;
      focusable[(index + direction + focusable.length) % focusable.length].focus();
    }
  });
})();
